import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { ITabsLayout, LayoutType } from '@components/layout';
import { MAIN_THEME } from '@styles';

export const headers: Record<string, EnhancedTableHeader> = {
  Policy_PolicyNumber: {
    name: 'PolicyNumber',
    title: 'Reference',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/policies/{policyId}',
    openUrlInNewTab: false,
  },
  PayableBills_TotalPremium: {
    name: 'TotalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  Policy_TotalAmountReceived: {
    name: 'AmountReceived',
    title: 'Amount Received',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBills_TotalCommission: {
    name: 'TotalCommission',
    title: 'Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBills_TaxOnCommission: {
    name: 'TaxOnCommission',
    title: 'Tax On Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBills_AmountPaid: {
    name: 'AmountPaid',
    title: 'Amount Paid',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  OutstandingPayable: {
    name: 'OutstandingPayable',
    title: 'Total Balance',
    type: EnhancedTableHeaderType.RoundedCurrency,
    disableSort: true,
  },
};

export const receivableBillsHeaders: Record<string, EnhancedTableHeader> = {
  reference: {
    name: 'reference',
    title: 'Reference',
    type: EnhancedTableHeaderType.Text,
  },
  BillNumber: {
    name: 'BillNumber',
    title: '#',
    type: EnhancedTableHeaderType.Text,
  },
  DueDate: {
    name: 'DueDate',
    title: 'Due Date',
    type: EnhancedTableHeaderType.Date,
  },
  NetPremium: {
    name: 'NetPremium',
    title: 'Net Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  TotalPremium: {
    name: 'TotalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmountDue: {
    name: 'AmountDue',
    title: 'Amount Due',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmountReceived: {
    name: 'AmountReceived',
    title: 'Amount Received',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  OutstandingBalance: {
    name: 'OutstandingBalance',
    title: 'Outstanding Amount',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  BillStatus: {
    name: 'BillStatus',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
};

export const payableBillsHeaders: Record<string, EnhancedTableHeader> = {
  reference: {
    name: 'reference',
    title: 'Reference',
    type: EnhancedTableHeaderType.Text,
  },
  BillNumber: {
    name: 'BillNumber',
    title: '#',
    type: EnhancedTableHeaderType.Text,
  },
  DueDate: {
    name: 'DueDate',
    title: 'Due Date',
    type: EnhancedTableHeaderType.Date,
  },
  Discount: {
    name: 'Discount',
    title: 'Discount',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  TotalCommission: {
    name: 'TotalCommission',
    title: 'Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  TaxOnCommission: {
    name: 'TaxOnCommission',
    title: 'Tax On Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  AmountReceived: {
    name: 'AmountReceived',
    title: 'Amount Paid',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  OutstandingBalance: {
    name: 'OutstandingBalance',
    title: 'Outstanding Amount',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  BillStatus: {
    name: 'BillStatus',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
};

export const RPTabs: ITabsLayout = {
  typeLogicalId: LayoutType.tabslayout,
  leftColumn: {
    backgroundColor: MAIN_THEME.color.white,
    collapsable: false,
    width: 2,
    collapsed: false,
  },
  mainColumn: {
    backgroundColor: MAIN_THEME.color.white98,
    collapsable: false,
    width: 10,
    collapsed: false,
  },
  rightColumn: {
    backgroundColor: MAIN_THEME.color.white,
    collapsable: false,
    width: 0,
    collapsed: false,
  },
  tabs: [
    {
      name: 'receivables',
      title: 'Receivables',
      iconUrl: '/icons/file-summary-primary.svg',
      widgets: [{}],
    },
    {
      name: 'payables',
      title: 'Payables',
      iconUrl: '/icons/file-summary-primary.svg',
      widgets: [{}],
    },
  ],
};

export const unallocatedTableHeaders: Record<string, EnhancedTableHeader> = {
  reference: {
    name: 'reference',
    title: 'Reference',
    type: EnhancedTableHeaderType.Text,
  },
  policy: {
    name: 'policy',
    title: 'Policy #',
    type: EnhancedTableHeaderType.Text,
  },
  amount: {
    name: 'amount',
    title: 'Amount',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  amountOutstanding: {
    name: 'amountOutstanding',
    title: 'Amount Outstanding',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  status: {
    name: 'status',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  modifiedBy: {
    name: 'modifiedBy',
    title: 'Modified By',
    type: EnhancedTableHeaderType.Text,
  },
};
